export default {
  doubleCount: (state) => state.counter * 2,
};
